import { S1Endpoint } from 'common/graphqlTypes';
import IcomoonIcon from 'components/common/Icon/IcomoonIcon';
import TruncateWithTooltip from 'components/common/TruncateWithTooltip/TruncateWithTooltip';
import { getEndpointIcon, getEndpointIconColor, getEndpointScope, getEndpointType } from './utils';

import './EndpointCardSummaryHeader.scss';

interface EndpointCardSummaryHeaderProps {
  endpointData: S1Endpoint;
}

/**
 * This component displays the endpoints card header
 * @prop endpointData     The endpoints data
 */
function EndpointCardSummaryHeader({ endpointData }: EndpointCardSummaryHeaderProps): JSX.Element {
  const endpointName = endpointData.computerName;
  const icon = getEndpointIcon(endpointData);
  const iconColor = getEndpointIconColor(endpointData);
  const endpointType = getEndpointType(endpointData);
  const endpointScope = getEndpointScope(endpointData);
  const notAvailable = 'N/A';

  return (
    <div className="EndpointCardSummaryHeader">
      <span className="EndpointCardSummaryHeader__Icon">
        <IcomoonIcon name={icon} size={48} color={iconColor} />
      </span>
      <div>
        <div className="EndpointCardSummaryHeader__Endpoint">
          <span className="EndpointCardSummaryHeader__EndpointName">
            <TruncateWithTooltip text={endpointName || notAvailable} maxLength={55} id={endpointType} />
          </span>
          <TruncateWithTooltip
            text={endpointType || notAvailable}
            maxLength={Math.max(62 - endpointName.length, 5)}
            id={endpointType}
          />
        </div>
        <div className="EndpointCardSummaryHeader__Scope">
          <TruncateWithTooltip text={endpointScope} maxLength={72} id={endpointType} />
        </div>
      </div>
    </div>
  );
}

export default EndpointCardSummaryHeader;
